<template>
  <div class="wizard-step-intro">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WizardIntro',
};
</script>

<style lang="postcss">
.wizard-step-intro {
  @apply mb-8;

  ul,
  ol {
    @apply list-outside pl-5 mb-3;
  }

  & > :last-child {
    @apply mb-0;
  }
}
</style>
